import { cn } from "@shortsworks/ui/lib/utils";
import { ScrollArea } from "@shortsworks/ui";
import { InspectorHeader } from "src/components/WidgetStudio/Inspector/InspectorHeader";
import {useEffect, useState, useImperativeHandle, forwardRef} from "react"
import { InspectorTabs } from "@app/components/WidgetStudio/Inspector/contracts/inspectorTabs";
import {
  WidgetStudioData,
  WidgetStudioDataType,
} from "@app/components/WidgetStudio/Inspector/schemas/widgetStudioData";
import { useDebounceValue } from "@app/hooks/useDebounce";
import {WidgetStudio} from "@app/components/WidgetStudio";

interface InspectorProps {
  className?: string;
  initialWidgetStudioData: WidgetStudioDataType;
  onValueChange: (value: Record<string, any> | any) => void;
  onResetValue?: any
}

export const Inspector = forwardRef(({ className, onValueChange, initialWidgetStudioData, onResetValue }: InspectorProps, ref) => {
  const [inspectorType, setInspectorType] = useState<string>("basic");
  const [widgetStudioData, setWidgetStudioData] = useState<WidgetStudioDataType>(initialWidgetStudioData);
  // const [groupIds, setGroupIds] = useState<string[]>([]);

  useEffect(() => {
    setWidgetStudioData(initialWidgetStudioData);
  }, [initialWidgetStudioData]);

  useImperativeHandle(ref, () => ({
    resetWidgetStudioData() {
      setWidgetStudioData(WidgetStudioData);
    }
  }));

  const debounceValue = useDebounceValue(widgetStudioData, 200);

  useEffect(() => {
    onValueChange(debounceValue);
  }, [debounceValue]);

  const handleInspectorTypeChange = (value: string) => {
    if (value === inspectorType || value === "") return;
    setInspectorType(value);
  };

  const handleValueChange = (value: Record<string, any>) => {
    setWidgetStudioData((prev) => {
      return {
        ...prev,
        ...value,
      };
    });
  };

  const renderInspector = () => {
    const tab = InspectorTabs.filter((tab) => tab.type !== "separator").find(
      (tab) => tab.id === inspectorType,
    );
    if (tab) {
      if (tab.autoScroll) {
        return (
          <ScrollArea type="scroll" className="w-full flex-1 p-4">
            <tab.content
              defaultFormValues={widgetStudioData}
              onValueChange={handleValueChange}
            />
          </ScrollArea>
        );
      }
      return (
        <div className="w-full flex-1 p-4 overflow-hidden">
          <tab.content
            defaultFormValues={widgetStudioData}
            onValueChange={handleValueChange}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div className={cn("w-full h-full flex flex-col", className)}>
      <InspectorHeader
        inspectorType={inspectorType}
        onInspectorTypeChange={handleInspectorTypeChange}
      />
      {renderInspector()}
    </div>
  );
});
